package com.neurobs.ccabserver.subjectsessionview.components.sessionselection

import com.neurobs.ccab.SessionDisplayData
import com.neurobs.ccabserver.subjectsessionview.components.sessionselection.components.SessionSelectionList
import com.neurobs.ccabserver.subjectsessionview.states.SessionSelectionStateGenerator
import com.neurobs.react.{ReactElementFactory, ReactUtil}
import com.neurobs.react.semanticui.{UiContainerFactory, UiDividerFactory, UiHeaderFactory, UiListFactory, UiLoaderFactory, UiMessageFactory}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import com.neurobs.js.util.StringUtilities.dateTimeString
import slinky.core.facade.ReactElement

import scala.scalajs.js

@react
object SessionSelection {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)

  val component = FunctionalComponent[Props] { props =>

    val sessionSelectionState = SessionSelectionStateGenerator.accessState

    def segmentStyle = Seq[(String, js.Any)](("maxHeight", "300px"), ("overflowY", "auto"))

    def LoadingElement = () => UiContainerFactory.Segment(
      UiLoaderFactory.ActiveTextLoader("Loading sessions...")
    )(segmentStyle)

    def ErrorElement = (error: String) => UiMessageFactory.BasicErrorMessage(s"There was an error loading sessions from the server: $error")

    def SessionsElement: List[SessionDisplayData] => ReactElement = (sessions: List[SessionDisplayData]) => {
      val sortedSessions = sessions.sortBy(_.session.session.startTime.instant.getEpochSecond)
      SessionSelectionList(sortedSessions)
    }

    props.enclosingElement(
      Seq[ReactElement](
        UiHeaderFactory.TextHeader("Sessions", 4),
        sessionSelectionState.sessionsState.ConditionalElements(
          LoadingElement = LoadingElement,
          ErrorElement = ErrorElement,
          DataElement = SessionsElement
        )
      )
    )
  }
}
